import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAdmin } from "@/admin/AuthContext";
import { PageHeader } from "@/components/admin/AdminUI";
import WaitlistTab from "@/components/admin/launch/WaitlistTab";
import WavesTab from "@/components/admin/launch/WavesTab";
import InviteCodesTab from "@/components/admin/launch/InviteCodesTab";
import ReferralsTab from "@/components/admin/launch/ReferralsTab";
import FoundingTab from "@/components/admin/launch/FoundingTab";

const TABS = [
  { key: "waitlist", label: "Waitlist", el: WaitlistTab, roles: ["owner", "support"] },
  { key: "waves", label: "Waves", el: WavesTab, roles: ["owner"] },
  { key: "codes", label: "Invite codes", el: InviteCodesTab, roles: ["owner"] },
  { key: "referrals", label: "Referrals", el: ReferralsTab, roles: ["owner"] },
  { key: "founding", label: "Founding Crush", el: FoundingTab, roles: ["owner"] },
];

export default function Launch() {
  const { admin } = useAdmin();
  const [params, setParams] = useSearchParams();
  const tabs = TABS.filter((t) => t.roles.includes(admin?.role));
  const tab = tabs.some((t) => t.key === params.get("tab")) ? params.get("tab") : tabs[0]?.key;
  return (
    <div data-testid="admin-launch-page">
      <PageHeader title="Launch" description="The waitlist, invite waves, codes, referrals and the Founding Crush badge." />
      <Tabs value={tab} onValueChange={(v) => setParams({ tab: v })}>
        <TabsList className="mb-6 h-auto flex-wrap">{tabs.map((t) => <TabsTrigger key={t.key} value={t.key} data-testid={`launch-tab-${t.key}`}>{t.label}</TabsTrigger>)}</TabsList>
        {tabs.map((t) => <TabsContent key={t.key} value={t.key}>{tab === t.key && <t.el />}</TabsContent>)}
      </Tabs>
    </div>
  );
}
